import React, { useState } from 'react';
import styled from 'styled-components';
import { AiFillCheckSquare, AiOutlineCheckSquare } from 'react-icons/ai'; // react-icons
import workoutApi from '../../../api/workout'; // workout api
import { WorkoutProps } from '../../../types/workout.types';
import Button from '../../../components/common/Button'; // button components
import WorkoutEditMode from './WorkoutEditMode'; // workout edit mode components
import { Color, Text } from '../../../styles/common'; // common styling

function WorkoutItem(props: WorkoutProps) {
  const { id, workout, isCompleted } = props.workout;
  const [ editMode, setEditMode ] = useState(false); // Edit Mode
  
  const onToggleIsCompleted = (e: React.FormEvent<HTMLDivElement>) => {
    workoutApi.updateWorkout(id, workout, !isCompleted);
  }
  const onSubmitEdit = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setEditMode(prev => !prev);
  }
  const onSubmitDelete = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    workoutApi.deleteWorkout(id);
  }

  return (
    <Container>
      <div>
        <div className='item-text'>
          <div className='item-text-edit'>
            { editMode
              ? <WorkoutEditMode
                editWorkouts={{ id, isCompleted }}
                editState={ setEditMode }
                />
              : <p>{workout}</p>
            }
          </div>
          
          <div className='item-text-icons' onClick={onToggleIsCompleted}>
            { isCompleted
              ? <AiFillCheckSquare size='30' />
              : <AiOutlineCheckSquare size='30'/>
            }
          </div>
        </div>
        <form>
          <Button
            onClick={onSubmitEdit}
            width='60px'
            height='100%'
            color={Color.BLACK}
            fontSize= {Text.SM}
            backgroundColor={Color.WHITE}
            colorHover={Color.WHITE}
            backgroundColorHover={Color.BLUE100}
          >Edit</Button>
          <Button
            onClick={onSubmitDelete}
            width='60px'
            height='100%'
            color={Color.BLACK}
            fontSize= {Text.SM}
            backgroundColor={Color.WHITE}
            colorHover={Color.WHITE}
            backgroundColorHover={Color.BLUE100}
          >Delete</Button>
        </form>
      </div>
    </Container>
  )
}

export default WorkoutItem;

const Container = styled.div`
  width: 100%;
  margin: 10px 0;
  
  div {
    width: 80%;
    height: 30px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    div.item-text {
      width: 70%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid ${ Color.GRAY100 };
      cursor: pointer;

      div.item-text-edit {
        width: 100%; /** item text width = 100% - icons width  */
        p {
          width: 220px;
          padding: 0;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      div.item-text-icons {
        width: 30px; /** same icons size */
        z-index: 1;
      }
    }
    
    form {
      width: 30%;
      height: 30px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
  }
`